export default __webpack_public_path__ + "static/media/constructionLogo.22c58909.svg";